import { render, staticRenderFns } from "./UserFormEmailField.vue?vue&type=template&id=b48bb3aa&"
import script from "./UserFormEmailField.vue?vue&type=script&lang=js&"
export * from "./UserFormEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports